import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'
import { handleError, handleSingleDataResponse } from '@/services/amio-api/utils/request-utils'

class OAuthService {
  constructor() {
    this.path = '/oauth'
  }

  oauthSmartsupp(code, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .post(`${this.path}/smartsupp`, {code})
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }
}

export default new OAuthService()
